import { z } from 'zod';

export const uploadUrlQueryParams = z.object({
  externalSlideScanId: z.string().min(1).describe('The slide-scan identifier provided by the integrator'),
});

export type UploadUrlQueryParamsType = z.infer<typeof uploadUrlQueryParams>;

export const uploadUrl = z
  .string()
  .describe(
    'The s3 upload url that contains the necessary secrets. Example: ' +
    'https://<my-bucket>.s3.<my-region>.amazonaws.com/<tenantId>/' +
    'wsi-passport.tar?X-AMZ-Algorithm=...&X-AMZ-Signature=...&...',
  );
export const RequestUploadUrlResponse = z.object({ uploadUrl });

// extract the inferred type
export type RequestUploadUrlResponseType = z.infer<typeof RequestUploadUrlResponse>;
